import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody
} from "react-bootstrap";
import "../css/dashboard.css";
import Appsidebar from "../../Appsidebar";
import Header from "../../Header";
import "../css/appsidebar.css";
import "../css/mobileappsidebar.css";
import { createChart, PriceScaleMode, ColorType } from "lightweight-charts";
import {
  getInfiChartData,
  getInfiPoolBalancetData,
} from "../../../services/apiServices";
// import "./componentCss/dashboardfooter.css";
import {
  TOKEN_A,
  STAKING_CONTRACT
} from "../../Web3/web3Config";

import { BloackchainGetTokenBalance, getSbseBalance,TokenBalanceData } from "../../Web3/SwapConnector";
import { BloackchainGetStakingTokensBalance } from "../../Web3/StakingConnector"
import {
  initializeUseSelector,
  useSelector,
} from "react-redux/es/hooks/useSelector";
import Web3ModalProvider from "../../Pages/Presale/Connectwallet/Web3ModalProvider";
import Tooltip from "react-bootstrap/Tooltip";

export const ChartComponent = (props) => {
  const {
    data,
    colors: {
      backgroundColor = "white",
      lineColor = "#2962FF",
      textColor = "black",
      areaTopColor = "#2962FF",
      areaBottomColor = "rgba(41, 98, 255, 0.28)",
    } = {},
  } = props;

  console.log("ChartComponentAppDashboard", data);

  const chartContainerRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    };

    const chart = createChart(chartContainerRef.current, {
      layout: {
        background: { type: ColorType.Solid, color: backgroundColor },
        textColor,
      },

      width: chartContainerRef.current.clientWidth,
      height: 500,
    });
    chart.timeScale().fitContent();

    const newSeries = chart.addAreaSeries({
      lineColor,
      topColor: areaTopColor,
      bottomColor: areaBottomColor,
    });
    newSeries.setData(data);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);

      chart.remove();
    };
  }, [
    data,
    backgroundColor,
    lineColor,
    textColor,
    areaTopColor,
    areaBottomColor,
  ]);

  return <div ref={chartContainerRef} />;
};

const AppDashboard = (props) => {
  const [poolBalanceData, setPoolBalanceData] = useState({});
  const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [initialData, setinitialData] = useState([]);
  const [tokenA, setTokenA] = useState(TOKEN_A);
  const [infibal, setinfibal] = useState(0);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const [WalletAddress, setWalletAddress] = useState("");
  const _useWeb3ModalProvider = Web3ModalProvider();
  const [reserveInfi, setReserveInfi] = useState(0)
  const [reserveUsdt, setReserveUsdt] = useState(0)
  const [treasuryInfi, setTreasuryInfi] = useState(0)
  const [treasuryUsdt, setTreasuryUsdt] = useState(0)
  const [sbseUsdt, setSbseUsdt] = useState(0)
  const [balances,setBalances] = useState(null)

  useEffect(() => {
    setWalletAddress(walletConnnected);
    setTimeout(() => {
      getWalletBalance();
    }, 1000);
  }, [walletConnnected]);

  const getWalletBalance = async (a) => {
    try {
      console.log(
        "tokenARes",
        walletConnnected,
        tokenA.contract,
        _useWeb3ModalProvider
      );
      let tokenARes = await BloackchainGetTokenBalance(
        walletConnnected,
        tokenA.contract,
        _useWeb3ModalProvider
      );

      if (tokenARes.status) {
        console.log(tokenARes.balance, "tokenARes.balance");
        setinfibal(tokenARes.balance);
      }
    } catch (error) {
      console.log("error in getWalletBalance", error);
    }
  };

  const dataToken = async () => {
    let res = await TokenBalanceData();
    //    console.log('BAL',res)
    if (res.status) {
      console.log(res.InfiBalanceReserve, "balance");
      setReserveInfi(res.InfiBalanceReserve)
      setTreasuryInfi(res.InfiBalanceTreasury)
      let usdtBalReserve = res.UsdtBalanceReserve
      let usdtBalTreasury = res.UsdtBalanceTreasury
      let bal = await BloackchainGetStakingTokensBalance(STAKING_CONTRACT)
      //console.log('BAL',bal)
      setReserveUsdt(usdtBalReserve)
      setTreasuryUsdt(usdtBalTreasury)

    }
  }

  useEffect(() => {
    const fetchbal = async () => {
      const res = await getSbseBalance()
     console.log('xxxxxxxx',res)
      if(res.status) {
        setBalances(res.balance)
      }
    }
    fetchbal()
  },[])

  useEffect(() => {
    getInfiPriceChart();
    dataToken()
    // if (walletConnnected) {
    getInfiPoolBalancetDataFun();
    // }
  }, []);

  const getInfiPriceChart = async () => {
    const res = await getInfiChartData();
    setinitialData(res.data.data);
    console.log(res.data);
  };

  const getInfiPoolBalancetDataFun = async () => {
    const res = await getInfiPoolBalancetData();
    if (res) {
      console.log(res.data);
      setPoolBalanceData(res.data.data);
    }
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Wallet connection required to check INFI token balance
    </Tooltip>
  );

  return (
    <>
      {/* <Dashboardheader /> */}
      <div className="dashboard">
        <Header
          connectWalletNow={connectWalletNow}
          setconnectWalletNow={setConnectWalletNow}
        />

        {/* <Dashboardheader /> */}

        <div className="wrapper">
          <Appsidebar />
          {/* <Mobileappsidebar/> */}
          <div id="content" className='position-relative'>
            <Container fluid className="pt-4">
              <Row>
                {/* <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        INFI Balance{" "}

                      </h4>
                      <p className="text-black mb-0">{parseFloat(infibal || 0).toFixed(4)} INFI </p>
                    </Card.Body>
                  </Card>
                </Col> */}
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        INFI Pool Balance{" "}

                      </h4>
                      <p className="text-black mb-0">{parseFloat(poolBalanceData.infi).toFixed(4) || 0} INFI</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">

                      <h4 className="text-primary fs-5 mb-1">
                        SbSe PFP USDT
                      </h4>
                      <p className="text-black mb-0">{parseFloat(balances?.USDT_BAL || 0).toFixed(6)} USDT</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe PFP WBTC
                      </h4>
                      <p className="text-black mb-0">{parseFloat(balances?.WBTC_BAL || 0).toFixed(8)} WBTC</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe PFP USDC
                      </h4>
                      <p className="text-black mb-0">{parseFloat(balances?.USDC_BAL || 0).toFixed(6)} USDC</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe PFP INFI :{" "}

                      </h4>
                      <p className="text-black mb-0">{parseFloat(balances?.INFI_BAL || 0).toFixed(4)} INFI</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe TREASURY USDT
                      </h4>
                      <p className="text-black mb-0">{treasuryUsdt || 0} USDT</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe RESERVE USDT
                      </h4>
                      <p className="text-black mb-0">{reserveUsdt || 0} USDT</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe TREASURY INFI
                      </h4>
                      <p className="text-black mb-0">{treasuryInfi || 0} INFI</p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={4} md={4} sm={4} className="mb-4">
                  <Card className="shadow border-0 ">
                    <Card.Body className="p-3">
                      <h4 className="text-primary fs-5 mb-1">
                        SbSe RESERVE INFI
                      </h4>
                      <p className="text-black mb-0">{reserveInfi || 0} INFI</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col lg={12} md={12} sm={12} className="mb-4">

                  <div class="chartgraph">
                    <h5 className="text-primary"></h5>
                    {initialData.length > 0 && (
                      <ChartComponent
                        {...props}
                        data={initialData}
                      ></ChartComponent>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppDashboard;
